import { store } from '../../../store'
import { MessageDataType } from '../types'
import { updateAllTickerAction } from '../../../store/market/actions'
import { SymbolName } from '../../../types'
import { TickerTuple } from '../../../api/v1/market'

export interface WsPricesData {
  type: 'prices'
  data: Record<SymbolName, TickerTuple>
}

export function onMessagePrices(data: MessageDataType) {
  switch (data.type) {
    // Receive last 24h price data of all symbols, data includes: open, high, low, close, volume and so on
    // used to display in the 'MarketDrawer and MarkerSearch and Assets and ...' component
    case 'prices':
      updatePrices(data as WsPricesData)
      break
  }
}

function updatePrices(data: WsPricesData) {
  store.dispatch(updateAllTickerAction(data.data))
}
